import React from "react"
import PropTypes from "prop-types"
import { Flex, Typography } from "antd"
import { Bar } from "react-chartjs-2"
import { useTranslation } from "react-i18next"
import { ANNUAL_SUMMARY_COLORS, CHART_COLORS, DONUT_COLORS, barChartOptions } from "../constants"
import { normalizeChartLabel } from "../utils"
import styles from "../style.module.css"

const { Text } = Typography

export default function AnnualSummaryWidget({ data, periodLabel }) {
  const { t } = useTranslation()
  // chart_data for bar: { labels, series: [{ name, data }] }
  const labels = (data?.labels ?? []).map((l) => normalizeChartLabel(l))
  const series = Array.isArray(data?.series) ? data.series : []
  const seriesColors = [ANNUAL_SUMMARY_COLORS.income, ANNUAL_SUMMARY_COLORS.expenses, CHART_COLORS.green, CHART_COLORS.purple]

  const chartData = {
    labels,
    datasets: series.map((s, i) => ({
      label: s.name,
      data: s.data,
      backgroundColor: seriesColors[i] ?? DONUT_COLORS[i % DONUT_COLORS.length]
    }))
  }

  return (
    <div className={styles.widgetContent}>
      <Flex justify="space-between" align="flex-start" className={styles.widgetHeader}>
        <div>
          <Text strong>{t("ai_dashboard.widget_annual_summary")}</Text>
          <Text type="secondary" className={styles.annualSubtitle}>{t("ai_dashboard.annual_subtitle")}</Text>
        </div>
        <span className={styles.periodTag}>{periodLabel}</span>
      </Flex>
      <div className={styles.chartWrapper}>
        <Bar data={chartData} options={barChartOptions} />
      </div>
    </div>
  )
}

AnnualSummaryWidget.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  periodLabel: PropTypes.string,
}
